module.exports = __webpack_public_path__ + "img/ziz3.9ce0ced1.png";